import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { Button } from "@masterteam/mt-design-react";
import { useDispatch, useSelector } from "react-redux";

import EditForm from "./EditForm";
import NewTable from "../NewTable";
import AdminPage from "../AdminPage";
import DeleteModal from "../DeleteModal";

import api from "../../providers/api";
import { addToast } from "../../helpers";

import { ReactComponent as EditIcon } from "../../assets/images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete.svg";
import { getStrategies, deleteStrategy } from "../../reducers/strategy";

const initialModalState = {
  isOpen: false,
  data: null,
};

const StrategiesPage = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const isAr = intl.locale === "ar";
  const [Strategies, StrategyTypes] = useSelector(({ strategy, theme }) => [
    strategy,
    theme.StrategyTypes.item.Items,
  ]);

  const [formModal, setFormModal] = useState(initialModalState);
  const [deleteModal, setDeleteModal] = useState(initialModalState);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    dispatch(getStrategies());
  }, []);

  const handleDelete = (id) => {
    setDeleteLoading(true);
    api.strategy
      .delete(id)
      .then((res) => {
        const { StatusCode, StatusMessage } = res;
        if (StatusCode === "Success") {
          dispatch(deleteStrategy(id));
          setDeleteModal(initialModalState);
          addToast.success("toast.successDelete");
        } else if (StatusCode === "fail") {
          addToast.error(StatusMessage, {
            toastId: "get-users-error",
          });
        }
      })
      .catch((error) => {
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      })
      .finally(() => {
        setDeleteLoading(false);
      });
  };

  return (
    <AdminPage
      title={intl.formatMessage({ id: "common.strategies" })}
      loading={Strategies?.isLoading}
    >
      <div
        style={{
          width: "40%",
        }}
      >
        <NewTable
          data={Strategies.strategies}
          actionsHeader={
            <Button
              fixed
              onClick={() => setFormModal({ isOpen: true, data: null })}
            >
              {intl.formatMessage({ id: "common.add" })}
            </Button>
          }
          columns={[
            {
              key: "Strategy Name",
              header: intl.formatMessage({
                id: "common.strategies",
              }),
              cell: (item) => (isAr ? item.ArabicName : item.EnglishName),
              width: "60%",
            },
            {
              key: "Type",
              header: intl.formatMessage({ id: "strategy.strategy-type" }),
              cell: (item) => {
                const type = StrategyTypes?.find(
                  (e) => +e.Value === +item?.StrategyType
                );

                return isAr ? type?.Arabic : type?.English;
              },
              width: "40%",
            },
          ]}
          actions={[
            {
              key: "edit",
              variant: "primary",
              Icon: EditIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.update" }),
              onClick: (item) => {
                setFormModal({ isOpen: true, data: item });
              },
            },
            {
              key: "delete",
              variant: "error",
              Icon: DeleteIcon,
              "tooltip-position": "buttom",
              tooltip: intl.formatMessage({ id: "common.delete" }),
              onClick: (item) => {
                setDeleteModal({ isOpen: true, data: item.ID });
              },
              disabled: (item) => !item.IsDeletable,
            },
          ]}
          compact
        />
      </div>

      {formModal.isOpen ? (
        <EditForm
          data={formModal.data}
          closeModal={() => setFormModal(initialModalState)}
        />
      ) : null}

      {deleteModal.isOpen ? (
        <DeleteModal
          isOpen={deleteModal.isOpen}
          title={intl.formatMessage({ id: "common.strategy" })}
          closeModal={() => setDeleteModal(initialModalState)}
          handleDelete={() => handleDelete(deleteModal.data)}
          ButtonStatus={deleteLoading}
        />
      ) : null}
    </AdminPage>
  );
};

export default StrategiesPage;
